import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class GradingReportingModel {
    @ApiProperty()
    @IsNotEmpty({message:"Count should not be empty"})
    grade: number;
    @ApiProperty()
    @IsNotEmpty({message:"Boxes should not be empty"})
    boxes: number;
    @ApiProperty()
    @IsNotEmpty({message:"Quantity should not be empty"})
    quantity: number;
}